import { useContext } from 'react';
import { SnackBarContext } from './SnackBarProvider';

/**
 * Hook for displaying snackbar notifications.
 * Must be used within a SnackBarProvider component.
 *
 * @returns {Object} Snackbar methods
 * @returns {Function} showSnackBar - Shows a snackbar with the provided options
 *
 * @example
 * ```tsx
 * const { showSnackBar } = useSnackBar();
 *
 * const handleSuccess = () => {
 *   showSnackBar({
 *     severity: 'success',
 *     title: 'Success',
 *     message: 'Operation completed successfully'
 *   });
 * };
 * ```
 *
 * @throws {Error} If used outside of SnackBarProvider
 */
export function useSnackBar() {
  const context = useContext(SnackBarContext);

  /* istanbul ignore next - This is a sanity check to ensure the context is used correctly */
  if (!context) {
    throw new Error('useSnackBar must be used within a SnackBarProvider');
  }

  return context;
}
